module.exports = __webpack_public_path__ + "static/media/find.3bb5eb42.jpeg";